module.exports = __webpack_public_path__ + "img/gemrush.a6022bf9.png";